export default [
  {
    id: 481978440,
    node_id: 'R_kgDOHLpoSA',
    name: 'github-yelpcamp',
    full_name: 'wujekbizon/github-yelpcamp',
    private: false,
    owner: {
      login: 'wujekbizon',
      id: 97871150,
      node_id: 'U_kgDOBdVlLg',
      avatar_url: 'https://avatars.githubusercontent.com/u/97871150?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/wujekbizon',
      html_url: 'https://github.com/wujekbizon',
      followers_url: 'https://api.github.com/users/wujekbizon/followers',
      following_url:
        'https://api.github.com/users/wujekbizon/following{/other_user}',
      gists_url: 'https://api.github.com/users/wujekbizon/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/wujekbizon/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/wujekbizon/subscriptions',
      organizations_url: 'https://api.github.com/users/wujekbizon/orgs',
      repos_url: 'https://api.github.com/users/wujekbizon/repos',
      events_url: 'https://api.github.com/users/wujekbizon/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/wujekbizon/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/wujekbizon/github-yelpcamp',
    description:
      'My first  web application, done in Express.js framework , full CRUD implementation , MongoDB.',
    fork: false,
    url: 'https://api.github.com/repos/wujekbizon/github-yelpcamp',
    forks_url: 'https://api.github.com/repos/wujekbizon/github-yelpcamp/forks',
    keys_url:
      'https://api.github.com/repos/wujekbizon/github-yelpcamp/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/wujekbizon/github-yelpcamp/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/wujekbizon/github-yelpcamp/teams',
    hooks_url: 'https://api.github.com/repos/wujekbizon/github-yelpcamp/hooks',
    issue_events_url:
      'https://api.github.com/repos/wujekbizon/github-yelpcamp/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/wujekbizon/github-yelpcamp/events',
    assignees_url:
      'https://api.github.com/repos/wujekbizon/github-yelpcamp/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/wujekbizon/github-yelpcamp/branches{/branch}',
    tags_url: 'https://api.github.com/repos/wujekbizon/github-yelpcamp/tags',
    blobs_url:
      'https://api.github.com/repos/wujekbizon/github-yelpcamp/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/wujekbizon/github-yelpcamp/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/wujekbizon/github-yelpcamp/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/wujekbizon/github-yelpcamp/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/wujekbizon/github-yelpcamp/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/wujekbizon/github-yelpcamp/languages',
    stargazers_url:
      'https://api.github.com/repos/wujekbizon/github-yelpcamp/stargazers',
    contributors_url:
      'https://api.github.com/repos/wujekbizon/github-yelpcamp/contributors',
    subscribers_url:
      'https://api.github.com/repos/wujekbizon/github-yelpcamp/subscribers',
    subscription_url:
      'https://api.github.com/repos/wujekbizon/github-yelpcamp/subscription',
    commits_url:
      'https://api.github.com/repos/wujekbizon/github-yelpcamp/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/wujekbizon/github-yelpcamp/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/wujekbizon/github-yelpcamp/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/wujekbizon/github-yelpcamp/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/wujekbizon/github-yelpcamp/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/wujekbizon/github-yelpcamp/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/wujekbizon/github-yelpcamp/merges',
    archive_url:
      'https://api.github.com/repos/wujekbizon/github-yelpcamp/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/wujekbizon/github-yelpcamp/downloads',
    issues_url:
      'https://api.github.com/repos/wujekbizon/github-yelpcamp/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/wujekbizon/github-yelpcamp/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/wujekbizon/github-yelpcamp/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/wujekbizon/github-yelpcamp/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/wujekbizon/github-yelpcamp/labels{/name}',
    releases_url:
      'https://api.github.com/repos/wujekbizon/github-yelpcamp/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/wujekbizon/github-yelpcamp/deployments',
    created_at: '2022-04-15T14:06:28Z',
    updated_at: '2022-04-15T14:09:38Z',
    pushed_at: '2022-05-03T20:15:45Z',
    git_url: 'git://github.com/wujekbizon/github-yelpcamp.git',
    ssh_url: 'git@github.com:wujekbizon/github-yelpcamp.git',
    clone_url: 'https://github.com/wujekbizon/github-yelpcamp.git',
    svn_url: 'https://github.com/wujekbizon/github-yelpcamp',
    homepage: null,
    size: 653,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 481989207,
    node_id: 'R_kgDOHLqSVw',
    name: 'jS-apps-lifeCounter',
    full_name: 'wujekbizon/jS-apps-lifeCounter',
    private: false,
    owner: {
      login: 'wujekbizon',
      id: 97871150,
      node_id: 'U_kgDOBdVlLg',
      avatar_url: 'https://avatars.githubusercontent.com/u/97871150?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/wujekbizon',
      html_url: 'https://github.com/wujekbizon',
      followers_url: 'https://api.github.com/users/wujekbizon/followers',
      following_url:
        'https://api.github.com/users/wujekbizon/following{/other_user}',
      gists_url: 'https://api.github.com/users/wujekbizon/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/wujekbizon/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/wujekbizon/subscriptions',
      organizations_url: 'https://api.github.com/users/wujekbizon/orgs',
      repos_url: 'https://api.github.com/users/wujekbizon/repos',
      events_url: 'https://api.github.com/users/wujekbizon/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/wujekbizon/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/wujekbizon/jS-apps-lifeCounter',
    description:
      'Small app for counting life total in card games like MTG. CSS - Bulma Library',
    fork: false,
    url: 'https://api.github.com/repos/wujekbizon/jS-apps-lifeCounter',
    forks_url:
      'https://api.github.com/repos/wujekbizon/jS-apps-lifeCounter/forks',
    keys_url:
      'https://api.github.com/repos/wujekbizon/jS-apps-lifeCounter/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/wujekbizon/jS-apps-lifeCounter/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/wujekbizon/jS-apps-lifeCounter/teams',
    hooks_url:
      'https://api.github.com/repos/wujekbizon/jS-apps-lifeCounter/hooks',
    issue_events_url:
      'https://api.github.com/repos/wujekbizon/jS-apps-lifeCounter/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/wujekbizon/jS-apps-lifeCounter/events',
    assignees_url:
      'https://api.github.com/repos/wujekbizon/jS-apps-lifeCounter/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/wujekbizon/jS-apps-lifeCounter/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/wujekbizon/jS-apps-lifeCounter/tags',
    blobs_url:
      'https://api.github.com/repos/wujekbizon/jS-apps-lifeCounter/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/wujekbizon/jS-apps-lifeCounter/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/wujekbizon/jS-apps-lifeCounter/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/wujekbizon/jS-apps-lifeCounter/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/wujekbizon/jS-apps-lifeCounter/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/wujekbizon/jS-apps-lifeCounter/languages',
    stargazers_url:
      'https://api.github.com/repos/wujekbizon/jS-apps-lifeCounter/stargazers',
    contributors_url:
      'https://api.github.com/repos/wujekbizon/jS-apps-lifeCounter/contributors',
    subscribers_url:
      'https://api.github.com/repos/wujekbizon/jS-apps-lifeCounter/subscribers',
    subscription_url:
      'https://api.github.com/repos/wujekbizon/jS-apps-lifeCounter/subscription',
    commits_url:
      'https://api.github.com/repos/wujekbizon/jS-apps-lifeCounter/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/wujekbizon/jS-apps-lifeCounter/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/wujekbizon/jS-apps-lifeCounter/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/wujekbizon/jS-apps-lifeCounter/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/wujekbizon/jS-apps-lifeCounter/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/wujekbizon/jS-apps-lifeCounter/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/wujekbizon/jS-apps-lifeCounter/merges',
    archive_url:
      'https://api.github.com/repos/wujekbizon/jS-apps-lifeCounter/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/wujekbizon/jS-apps-lifeCounter/downloads',
    issues_url:
      'https://api.github.com/repos/wujekbizon/jS-apps-lifeCounter/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/wujekbizon/jS-apps-lifeCounter/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/wujekbizon/jS-apps-lifeCounter/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/wujekbizon/jS-apps-lifeCounter/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/wujekbizon/jS-apps-lifeCounter/labels{/name}',
    releases_url:
      'https://api.github.com/repos/wujekbizon/jS-apps-lifeCounter/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/wujekbizon/jS-apps-lifeCounter/deployments',
    created_at: '2022-04-15T14:44:32Z',
    updated_at: '2022-05-18T15:47:53Z',
    pushed_at: '2022-05-18T16:26:19Z',
    git_url: 'git://github.com/wujekbizon/jS-apps-lifeCounter.git',
    ssh_url: 'git@github.com:wujekbizon/jS-apps-lifeCounter.git',
    clone_url: 'https://github.com/wujekbizon/jS-apps-lifeCounter.git',
    svn_url: 'https://github.com/wujekbizon/jS-apps-lifeCounter',
    homepage: 'https://js-lifecounter.vercel.app/',
    size: 22,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 493967137,
    node_id: 'R_kgDOHXFXIQ',
    name: 'js-apps-movieFight',
    full_name: 'wujekbizon/js-apps-movieFight',
    private: false,
    owner: {
      login: 'wujekbizon',
      id: 97871150,
      node_id: 'U_kgDOBdVlLg',
      avatar_url: 'https://avatars.githubusercontent.com/u/97871150?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/wujekbizon',
      html_url: 'https://github.com/wujekbizon',
      followers_url: 'https://api.github.com/users/wujekbizon/followers',
      following_url:
        'https://api.github.com/users/wujekbizon/following{/other_user}',
      gists_url: 'https://api.github.com/users/wujekbizon/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/wujekbizon/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/wujekbizon/subscriptions',
      organizations_url: 'https://api.github.com/users/wujekbizon/orgs',
      repos_url: 'https://api.github.com/users/wujekbizon/repos',
      events_url: 'https://api.github.com/users/wujekbizon/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/wujekbizon/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/wujekbizon/js-apps-movieFight',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/wujekbizon/js-apps-movieFight',
    forks_url:
      'https://api.github.com/repos/wujekbizon/js-apps-movieFight/forks',
    keys_url:
      'https://api.github.com/repos/wujekbizon/js-apps-movieFight/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/wujekbizon/js-apps-movieFight/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/wujekbizon/js-apps-movieFight/teams',
    hooks_url:
      'https://api.github.com/repos/wujekbizon/js-apps-movieFight/hooks',
    issue_events_url:
      'https://api.github.com/repos/wujekbizon/js-apps-movieFight/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/wujekbizon/js-apps-movieFight/events',
    assignees_url:
      'https://api.github.com/repos/wujekbizon/js-apps-movieFight/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/wujekbizon/js-apps-movieFight/branches{/branch}',
    tags_url: 'https://api.github.com/repos/wujekbizon/js-apps-movieFight/tags',
    blobs_url:
      'https://api.github.com/repos/wujekbizon/js-apps-movieFight/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/wujekbizon/js-apps-movieFight/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/wujekbizon/js-apps-movieFight/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/wujekbizon/js-apps-movieFight/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/wujekbizon/js-apps-movieFight/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/wujekbizon/js-apps-movieFight/languages',
    stargazers_url:
      'https://api.github.com/repos/wujekbizon/js-apps-movieFight/stargazers',
    contributors_url:
      'https://api.github.com/repos/wujekbizon/js-apps-movieFight/contributors',
    subscribers_url:
      'https://api.github.com/repos/wujekbizon/js-apps-movieFight/subscribers',
    subscription_url:
      'https://api.github.com/repos/wujekbizon/js-apps-movieFight/subscription',
    commits_url:
      'https://api.github.com/repos/wujekbizon/js-apps-movieFight/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/wujekbizon/js-apps-movieFight/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/wujekbizon/js-apps-movieFight/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/wujekbizon/js-apps-movieFight/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/wujekbizon/js-apps-movieFight/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/wujekbizon/js-apps-movieFight/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/wujekbizon/js-apps-movieFight/merges',
    archive_url:
      'https://api.github.com/repos/wujekbizon/js-apps-movieFight/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/wujekbizon/js-apps-movieFight/downloads',
    issues_url:
      'https://api.github.com/repos/wujekbizon/js-apps-movieFight/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/wujekbizon/js-apps-movieFight/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/wujekbizon/js-apps-movieFight/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/wujekbizon/js-apps-movieFight/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/wujekbizon/js-apps-movieFight/labels{/name}',
    releases_url:
      'https://api.github.com/repos/wujekbizon/js-apps-movieFight/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/wujekbizon/js-apps-movieFight/deployments',
    created_at: '2022-05-19T07:32:02Z',
    updated_at: '2022-05-19T07:35:29Z',
    pushed_at: '2022-05-19T09:13:50Z',
    git_url: 'git://github.com/wujekbizon/js-apps-movieFight.git',
    ssh_url: 'git@github.com:wujekbizon/js-apps-movieFight.git',
    clone_url: 'https://github.com/wujekbizon/js-apps-movieFight.git',
    svn_url: 'https://github.com/wujekbizon/js-apps-movieFight',
    homepage: 'js-apps-movie-fight.vercel.app',
    size: 5,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 487046915,
    node_id: 'R_kgDOHQe_Aw',
    name: 'Js-codingExercise',
    full_name: 'wujekbizon/Js-codingExercise',
    private: false,
    owner: {
      login: 'wujekbizon',
      id: 97871150,
      node_id: 'U_kgDOBdVlLg',
      avatar_url: 'https://avatars.githubusercontent.com/u/97871150?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/wujekbizon',
      html_url: 'https://github.com/wujekbizon',
      followers_url: 'https://api.github.com/users/wujekbizon/followers',
      following_url:
        'https://api.github.com/users/wujekbizon/following{/other_user}',
      gists_url: 'https://api.github.com/users/wujekbizon/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/wujekbizon/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/wujekbizon/subscriptions',
      organizations_url: 'https://api.github.com/users/wujekbizon/orgs',
      repos_url: 'https://api.github.com/users/wujekbizon/repos',
      events_url: 'https://api.github.com/users/wujekbizon/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/wujekbizon/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/wujekbizon/Js-codingExercise',
    description: 'All the fun Javascript Algorithms + Data Structures Exercise',
    fork: false,
    url: 'https://api.github.com/repos/wujekbizon/Js-codingExercise',
    forks_url:
      'https://api.github.com/repos/wujekbizon/Js-codingExercise/forks',
    keys_url:
      'https://api.github.com/repos/wujekbizon/Js-codingExercise/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/wujekbizon/Js-codingExercise/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/wujekbizon/Js-codingExercise/teams',
    hooks_url:
      'https://api.github.com/repos/wujekbizon/Js-codingExercise/hooks',
    issue_events_url:
      'https://api.github.com/repos/wujekbizon/Js-codingExercise/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/wujekbizon/Js-codingExercise/events',
    assignees_url:
      'https://api.github.com/repos/wujekbizon/Js-codingExercise/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/wujekbizon/Js-codingExercise/branches{/branch}',
    tags_url: 'https://api.github.com/repos/wujekbizon/Js-codingExercise/tags',
    blobs_url:
      'https://api.github.com/repos/wujekbizon/Js-codingExercise/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/wujekbizon/Js-codingExercise/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/wujekbizon/Js-codingExercise/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/wujekbizon/Js-codingExercise/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/wujekbizon/Js-codingExercise/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/wujekbizon/Js-codingExercise/languages',
    stargazers_url:
      'https://api.github.com/repos/wujekbizon/Js-codingExercise/stargazers',
    contributors_url:
      'https://api.github.com/repos/wujekbizon/Js-codingExercise/contributors',
    subscribers_url:
      'https://api.github.com/repos/wujekbizon/Js-codingExercise/subscribers',
    subscription_url:
      'https://api.github.com/repos/wujekbizon/Js-codingExercise/subscription',
    commits_url:
      'https://api.github.com/repos/wujekbizon/Js-codingExercise/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/wujekbizon/Js-codingExercise/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/wujekbizon/Js-codingExercise/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/wujekbizon/Js-codingExercise/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/wujekbizon/Js-codingExercise/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/wujekbizon/Js-codingExercise/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/wujekbizon/Js-codingExercise/merges',
    archive_url:
      'https://api.github.com/repos/wujekbizon/Js-codingExercise/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/wujekbizon/Js-codingExercise/downloads',
    issues_url:
      'https://api.github.com/repos/wujekbizon/Js-codingExercise/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/wujekbizon/Js-codingExercise/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/wujekbizon/Js-codingExercise/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/wujekbizon/Js-codingExercise/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/wujekbizon/Js-codingExercise/labels{/name}',
    releases_url:
      'https://api.github.com/repos/wujekbizon/Js-codingExercise/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/wujekbizon/Js-codingExercise/deployments',
    created_at: '2022-04-29T16:52:13Z',
    updated_at: '2022-04-29T18:06:23Z',
    pushed_at: '2022-05-26T12:41:34Z',
    git_url: 'git://github.com/wujekbizon/Js-codingExercise.git',
    ssh_url: 'git@github.com:wujekbizon/Js-codingExercise.git',
    clone_url: 'https://github.com/wujekbizon/Js-codingExercise.git',
    svn_url: 'https://github.com/wujekbizon/Js-codingExercise',
    homepage: null,
    size: 36,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 502256248,
    node_id: 'R_kgDOHe_SeA',
    name: 'js-mwdapi',
    full_name: 'wujekbizon/js-mwdapi',
    private: false,
    owner: {
      login: 'wujekbizon',
      id: 97871150,
      node_id: 'U_kgDOBdVlLg',
      avatar_url: 'https://avatars.githubusercontent.com/u/97871150?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/wujekbizon',
      html_url: 'https://github.com/wujekbizon',
      followers_url: 'https://api.github.com/users/wujekbizon/followers',
      following_url:
        'https://api.github.com/users/wujekbizon/following{/other_user}',
      gists_url: 'https://api.github.com/users/wujekbizon/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/wujekbizon/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/wujekbizon/subscriptions',
      organizations_url: 'https://api.github.com/users/wujekbizon/orgs',
      repos_url: 'https://api.github.com/users/wujekbizon/repos',
      events_url: 'https://api.github.com/users/wujekbizon/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/wujekbizon/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/wujekbizon/js-mwdapi',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/wujekbizon/js-mwdapi',
    forks_url: 'https://api.github.com/repos/wujekbizon/js-mwdapi/forks',
    keys_url: 'https://api.github.com/repos/wujekbizon/js-mwdapi/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/wujekbizon/js-mwdapi/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/wujekbizon/js-mwdapi/teams',
    hooks_url: 'https://api.github.com/repos/wujekbizon/js-mwdapi/hooks',
    issue_events_url:
      'https://api.github.com/repos/wujekbizon/js-mwdapi/issues/events{/number}',
    events_url: 'https://api.github.com/repos/wujekbizon/js-mwdapi/events',
    assignees_url:
      'https://api.github.com/repos/wujekbizon/js-mwdapi/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/wujekbizon/js-mwdapi/branches{/branch}',
    tags_url: 'https://api.github.com/repos/wujekbizon/js-mwdapi/tags',
    blobs_url:
      'https://api.github.com/repos/wujekbizon/js-mwdapi/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/wujekbizon/js-mwdapi/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/wujekbizon/js-mwdapi/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/wujekbizon/js-mwdapi/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/wujekbizon/js-mwdapi/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/wujekbizon/js-mwdapi/languages',
    stargazers_url:
      'https://api.github.com/repos/wujekbizon/js-mwdapi/stargazers',
    contributors_url:
      'https://api.github.com/repos/wujekbizon/js-mwdapi/contributors',
    subscribers_url:
      'https://api.github.com/repos/wujekbizon/js-mwdapi/subscribers',
    subscription_url:
      'https://api.github.com/repos/wujekbizon/js-mwdapi/subscription',
    commits_url:
      'https://api.github.com/repos/wujekbizon/js-mwdapi/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/wujekbizon/js-mwdapi/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/wujekbizon/js-mwdapi/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/wujekbizon/js-mwdapi/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/wujekbizon/js-mwdapi/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/wujekbizon/js-mwdapi/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/wujekbizon/js-mwdapi/merges',
    archive_url:
      'https://api.github.com/repos/wujekbizon/js-mwdapi/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/wujekbizon/js-mwdapi/downloads',
    issues_url:
      'https://api.github.com/repos/wujekbizon/js-mwdapi/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/wujekbizon/js-mwdapi/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/wujekbizon/js-mwdapi/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/wujekbizon/js-mwdapi/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/wujekbizon/js-mwdapi/labels{/name}',
    releases_url:
      'https://api.github.com/repos/wujekbizon/js-mwdapi/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/wujekbizon/js-mwdapi/deployments',
    created_at: '2022-06-11T05:11:19Z',
    updated_at: '2022-06-19T17:59:09Z',
    pushed_at: '2022-06-20T06:19:40Z',
    git_url: 'git://github.com/wujekbizon/js-mwdapi.git',
    ssh_url: 'git@github.com:wujekbizon/js-mwdapi.git',
    clone_url: 'https://github.com/wujekbizon/js-mwdapi.git',
    svn_url: 'https://github.com/wujekbizon/js-mwdapi',
    homepage: 'js-mwdapi.vercel.app',
    size: 432,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 508769390,
    node_id: 'R_kgDOHlM0bg',
    name: 'mwd-admin-panel',
    full_name: 'wujekbizon/mwd-admin-panel',
    private: false,
    owner: {
      login: 'wujekbizon',
      id: 97871150,
      node_id: 'U_kgDOBdVlLg',
      avatar_url: 'https://avatars.githubusercontent.com/u/97871150?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/wujekbizon',
      html_url: 'https://github.com/wujekbizon',
      followers_url: 'https://api.github.com/users/wujekbizon/followers',
      following_url:
        'https://api.github.com/users/wujekbizon/following{/other_user}',
      gists_url: 'https://api.github.com/users/wujekbizon/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/wujekbizon/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/wujekbizon/subscriptions',
      organizations_url: 'https://api.github.com/users/wujekbizon/orgs',
      repos_url: 'https://api.github.com/users/wujekbizon/repos',
      events_url: 'https://api.github.com/users/wujekbizon/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/wujekbizon/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/wujekbizon/mwd-admin-panel',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/wujekbizon/mwd-admin-panel',
    forks_url: 'https://api.github.com/repos/wujekbizon/mwd-admin-panel/forks',
    keys_url:
      'https://api.github.com/repos/wujekbizon/mwd-admin-panel/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/wujekbizon/mwd-admin-panel/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/wujekbizon/mwd-admin-panel/teams',
    hooks_url: 'https://api.github.com/repos/wujekbizon/mwd-admin-panel/hooks',
    issue_events_url:
      'https://api.github.com/repos/wujekbizon/mwd-admin-panel/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/wujekbizon/mwd-admin-panel/events',
    assignees_url:
      'https://api.github.com/repos/wujekbizon/mwd-admin-panel/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/wujekbizon/mwd-admin-panel/branches{/branch}',
    tags_url: 'https://api.github.com/repos/wujekbizon/mwd-admin-panel/tags',
    blobs_url:
      'https://api.github.com/repos/wujekbizon/mwd-admin-panel/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/wujekbizon/mwd-admin-panel/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/wujekbizon/mwd-admin-panel/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/wujekbizon/mwd-admin-panel/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/wujekbizon/mwd-admin-panel/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/wujekbizon/mwd-admin-panel/languages',
    stargazers_url:
      'https://api.github.com/repos/wujekbizon/mwd-admin-panel/stargazers',
    contributors_url:
      'https://api.github.com/repos/wujekbizon/mwd-admin-panel/contributors',
    subscribers_url:
      'https://api.github.com/repos/wujekbizon/mwd-admin-panel/subscribers',
    subscription_url:
      'https://api.github.com/repos/wujekbizon/mwd-admin-panel/subscription',
    commits_url:
      'https://api.github.com/repos/wujekbizon/mwd-admin-panel/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/wujekbizon/mwd-admin-panel/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/wujekbizon/mwd-admin-panel/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/wujekbizon/mwd-admin-panel/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/wujekbizon/mwd-admin-panel/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/wujekbizon/mwd-admin-panel/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/wujekbizon/mwd-admin-panel/merges',
    archive_url:
      'https://api.github.com/repos/wujekbizon/mwd-admin-panel/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/wujekbizon/mwd-admin-panel/downloads',
    issues_url:
      'https://api.github.com/repos/wujekbizon/mwd-admin-panel/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/wujekbizon/mwd-admin-panel/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/wujekbizon/mwd-admin-panel/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/wujekbizon/mwd-admin-panel/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/wujekbizon/mwd-admin-panel/labels{/name}',
    releases_url:
      'https://api.github.com/repos/wujekbizon/mwd-admin-panel/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/wujekbizon/mwd-admin-panel/deployments',
    created_at: '2022-06-29T16:34:21Z',
    updated_at: '2022-06-29T16:37:31Z',
    pushed_at: '2022-06-29T16:41:23Z',
    git_url: 'git://github.com/wujekbizon/mwd-admin-panel.git',
    ssh_url: 'git@github.com:wujekbizon/mwd-admin-panel.git',
    clone_url: 'https://github.com/wujekbizon/mwd-admin-panel.git',
    svn_url: 'https://github.com/wujekbizon/mwd-admin-panel',
    homepage: null,
    size: 1459,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 503630130,
    node_id: 'R_kgDOHgTJMg',
    name: 'react-admin-panel',
    full_name: 'wujekbizon/react-admin-panel',
    private: false,
    owner: {
      login: 'wujekbizon',
      id: 97871150,
      node_id: 'U_kgDOBdVlLg',
      avatar_url: 'https://avatars.githubusercontent.com/u/97871150?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/wujekbizon',
      html_url: 'https://github.com/wujekbizon',
      followers_url: 'https://api.github.com/users/wujekbizon/followers',
      following_url:
        'https://api.github.com/users/wujekbizon/following{/other_user}',
      gists_url: 'https://api.github.com/users/wujekbizon/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/wujekbizon/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/wujekbizon/subscriptions',
      organizations_url: 'https://api.github.com/users/wujekbizon/orgs',
      repos_url: 'https://api.github.com/users/wujekbizon/repos',
      events_url: 'https://api.github.com/users/wujekbizon/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/wujekbizon/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/wujekbizon/react-admin-panel',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/wujekbizon/react-admin-panel',
    forks_url:
      'https://api.github.com/repos/wujekbizon/react-admin-panel/forks',
    keys_url:
      'https://api.github.com/repos/wujekbizon/react-admin-panel/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/wujekbizon/react-admin-panel/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/wujekbizon/react-admin-panel/teams',
    hooks_url:
      'https://api.github.com/repos/wujekbizon/react-admin-panel/hooks',
    issue_events_url:
      'https://api.github.com/repos/wujekbizon/react-admin-panel/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/wujekbizon/react-admin-panel/events',
    assignees_url:
      'https://api.github.com/repos/wujekbizon/react-admin-panel/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/wujekbizon/react-admin-panel/branches{/branch}',
    tags_url: 'https://api.github.com/repos/wujekbizon/react-admin-panel/tags',
    blobs_url:
      'https://api.github.com/repos/wujekbizon/react-admin-panel/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/wujekbizon/react-admin-panel/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/wujekbizon/react-admin-panel/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/wujekbizon/react-admin-panel/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/wujekbizon/react-admin-panel/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/wujekbizon/react-admin-panel/languages',
    stargazers_url:
      'https://api.github.com/repos/wujekbizon/react-admin-panel/stargazers',
    contributors_url:
      'https://api.github.com/repos/wujekbizon/react-admin-panel/contributors',
    subscribers_url:
      'https://api.github.com/repos/wujekbizon/react-admin-panel/subscribers',
    subscription_url:
      'https://api.github.com/repos/wujekbizon/react-admin-panel/subscription',
    commits_url:
      'https://api.github.com/repos/wujekbizon/react-admin-panel/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/wujekbizon/react-admin-panel/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/wujekbizon/react-admin-panel/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/wujekbizon/react-admin-panel/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/wujekbizon/react-admin-panel/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/wujekbizon/react-admin-panel/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/wujekbizon/react-admin-panel/merges',
    archive_url:
      'https://api.github.com/repos/wujekbizon/react-admin-panel/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/wujekbizon/react-admin-panel/downloads',
    issues_url:
      'https://api.github.com/repos/wujekbizon/react-admin-panel/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/wujekbizon/react-admin-panel/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/wujekbizon/react-admin-panel/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/wujekbizon/react-admin-panel/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/wujekbizon/react-admin-panel/labels{/name}',
    releases_url:
      'https://api.github.com/repos/wujekbizon/react-admin-panel/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/wujekbizon/react-admin-panel/deployments',
    created_at: '2022-06-15T05:40:28Z',
    updated_at: '2022-06-19T06:14:26Z',
    pushed_at: '2022-06-20T19:10:32Z',
    git_url: 'git://github.com/wujekbizon/react-admin-panel.git',
    ssh_url: 'git@github.com:wujekbizon/react-admin-panel.git',
    clone_url: 'https://github.com/wujekbizon/react-admin-panel.git',
    svn_url: 'https://github.com/wujekbizon/react-admin-panel',
    homepage: 'react-admin-panel-wheat.vercel.app',
    size: 2165,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 504885768,
    node_id: 'R_kgDOHhfyCA',
    name: 'react-Frontend_Intern-task',
    full_name: 'wujekbizon/react-Frontend_Intern-task',
    private: false,
    owner: {
      login: 'wujekbizon',
      id: 97871150,
      node_id: 'U_kgDOBdVlLg',
      avatar_url: 'https://avatars.githubusercontent.com/u/97871150?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/wujekbizon',
      html_url: 'https://github.com/wujekbizon',
      followers_url: 'https://api.github.com/users/wujekbizon/followers',
      following_url:
        'https://api.github.com/users/wujekbizon/following{/other_user}',
      gists_url: 'https://api.github.com/users/wujekbizon/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/wujekbizon/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/wujekbizon/subscriptions',
      organizations_url: 'https://api.github.com/users/wujekbizon/orgs',
      repos_url: 'https://api.github.com/users/wujekbizon/repos',
      events_url: 'https://api.github.com/users/wujekbizon/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/wujekbizon/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/wujekbizon/react-Frontend_Intern-task',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/wujekbizon/react-Frontend_Intern-task',
    forks_url:
      'https://api.github.com/repos/wujekbizon/react-Frontend_Intern-task/forks',
    keys_url:
      'https://api.github.com/repos/wujekbizon/react-Frontend_Intern-task/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/wujekbizon/react-Frontend_Intern-task/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/wujekbizon/react-Frontend_Intern-task/teams',
    hooks_url:
      'https://api.github.com/repos/wujekbizon/react-Frontend_Intern-task/hooks',
    issue_events_url:
      'https://api.github.com/repos/wujekbizon/react-Frontend_Intern-task/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/wujekbizon/react-Frontend_Intern-task/events',
    assignees_url:
      'https://api.github.com/repos/wujekbizon/react-Frontend_Intern-task/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/wujekbizon/react-Frontend_Intern-task/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/wujekbizon/react-Frontend_Intern-task/tags',
    blobs_url:
      'https://api.github.com/repos/wujekbizon/react-Frontend_Intern-task/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/wujekbizon/react-Frontend_Intern-task/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/wujekbizon/react-Frontend_Intern-task/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/wujekbizon/react-Frontend_Intern-task/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/wujekbizon/react-Frontend_Intern-task/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/wujekbizon/react-Frontend_Intern-task/languages',
    stargazers_url:
      'https://api.github.com/repos/wujekbizon/react-Frontend_Intern-task/stargazers',
    contributors_url:
      'https://api.github.com/repos/wujekbizon/react-Frontend_Intern-task/contributors',
    subscribers_url:
      'https://api.github.com/repos/wujekbizon/react-Frontend_Intern-task/subscribers',
    subscription_url:
      'https://api.github.com/repos/wujekbizon/react-Frontend_Intern-task/subscription',
    commits_url:
      'https://api.github.com/repos/wujekbizon/react-Frontend_Intern-task/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/wujekbizon/react-Frontend_Intern-task/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/wujekbizon/react-Frontend_Intern-task/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/wujekbizon/react-Frontend_Intern-task/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/wujekbizon/react-Frontend_Intern-task/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/wujekbizon/react-Frontend_Intern-task/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/wujekbizon/react-Frontend_Intern-task/merges',
    archive_url:
      'https://api.github.com/repos/wujekbizon/react-Frontend_Intern-task/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/wujekbizon/react-Frontend_Intern-task/downloads',
    issues_url:
      'https://api.github.com/repos/wujekbizon/react-Frontend_Intern-task/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/wujekbizon/react-Frontend_Intern-task/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/wujekbizon/react-Frontend_Intern-task/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/wujekbizon/react-Frontend_Intern-task/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/wujekbizon/react-Frontend_Intern-task/labels{/name}',
    releases_url:
      'https://api.github.com/repos/wujekbizon/react-Frontend_Intern-task/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/wujekbizon/react-Frontend_Intern-task/deployments',
    created_at: '2022-06-18T15:50:46Z',
    updated_at: '2022-06-19T10:33:29Z',
    pushed_at: '2022-06-18T15:54:26Z',
    git_url: 'git://github.com/wujekbizon/react-Frontend_Intern-task.git',
    ssh_url: 'git@github.com:wujekbizon/react-Frontend_Intern-task.git',
    clone_url: 'https://github.com/wujekbizon/react-Frontend_Intern-task.git',
    svn_url: 'https://github.com/wujekbizon/react-Frontend_Intern-task',
    homepage: 'react-frontend-intern-task.vercel.app',
    size: 311,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 514754535,
    node_id: 'R_kgDOHq6H5w',
    name: 'react-github-users',
    full_name: 'wujekbizon/react-github-users',
    private: false,
    owner: {
      login: 'wujekbizon',
      id: 97871150,
      node_id: 'U_kgDOBdVlLg',
      avatar_url: 'https://avatars.githubusercontent.com/u/97871150?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/wujekbizon',
      html_url: 'https://github.com/wujekbizon',
      followers_url: 'https://api.github.com/users/wujekbizon/followers',
      following_url:
        'https://api.github.com/users/wujekbizon/following{/other_user}',
      gists_url: 'https://api.github.com/users/wujekbizon/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/wujekbizon/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/wujekbizon/subscriptions',
      organizations_url: 'https://api.github.com/users/wujekbizon/orgs',
      repos_url: 'https://api.github.com/users/wujekbizon/repos',
      events_url: 'https://api.github.com/users/wujekbizon/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/wujekbizon/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/wujekbizon/react-github-users',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/wujekbizon/react-github-users',
    forks_url:
      'https://api.github.com/repos/wujekbizon/react-github-users/forks',
    keys_url:
      'https://api.github.com/repos/wujekbizon/react-github-users/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/wujekbizon/react-github-users/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/wujekbizon/react-github-users/teams',
    hooks_url:
      'https://api.github.com/repos/wujekbizon/react-github-users/hooks',
    issue_events_url:
      'https://api.github.com/repos/wujekbizon/react-github-users/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/wujekbizon/react-github-users/events',
    assignees_url:
      'https://api.github.com/repos/wujekbizon/react-github-users/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/wujekbizon/react-github-users/branches{/branch}',
    tags_url: 'https://api.github.com/repos/wujekbizon/react-github-users/tags',
    blobs_url:
      'https://api.github.com/repos/wujekbizon/react-github-users/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/wujekbizon/react-github-users/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/wujekbizon/react-github-users/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/wujekbizon/react-github-users/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/wujekbizon/react-github-users/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/wujekbizon/react-github-users/languages',
    stargazers_url:
      'https://api.github.com/repos/wujekbizon/react-github-users/stargazers',
    contributors_url:
      'https://api.github.com/repos/wujekbizon/react-github-users/contributors',
    subscribers_url:
      'https://api.github.com/repos/wujekbizon/react-github-users/subscribers',
    subscription_url:
      'https://api.github.com/repos/wujekbizon/react-github-users/subscription',
    commits_url:
      'https://api.github.com/repos/wujekbizon/react-github-users/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/wujekbizon/react-github-users/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/wujekbizon/react-github-users/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/wujekbizon/react-github-users/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/wujekbizon/react-github-users/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/wujekbizon/react-github-users/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/wujekbizon/react-github-users/merges',
    archive_url:
      'https://api.github.com/repos/wujekbizon/react-github-users/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/wujekbizon/react-github-users/downloads',
    issues_url:
      'https://api.github.com/repos/wujekbizon/react-github-users/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/wujekbizon/react-github-users/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/wujekbizon/react-github-users/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/wujekbizon/react-github-users/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/wujekbizon/react-github-users/labels{/name}',
    releases_url:
      'https://api.github.com/repos/wujekbizon/react-github-users/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/wujekbizon/react-github-users/deployments',
    created_at: '2022-07-17T05:25:55Z',
    updated_at: '2022-07-17T05:36:35Z',
    pushed_at: '2022-07-17T05:36:32Z',
    git_url: 'git://github.com/wujekbizon/react-github-users.git',
    ssh_url: 'git@github.com:wujekbizon/react-github-users.git',
    clone_url: 'https://github.com/wujekbizon/react-github-users.git',
    svn_url: 'https://github.com/wujekbizon/react-github-users',
    homepage: null,
    size: 426,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 512632689,
    node_id: 'R_kgDOHo4ncQ',
    name: 'react-jobster',
    full_name: 'wujekbizon/react-jobster',
    private: false,
    owner: {
      login: 'wujekbizon',
      id: 97871150,
      node_id: 'U_kgDOBdVlLg',
      avatar_url: 'https://avatars.githubusercontent.com/u/97871150?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/wujekbizon',
      html_url: 'https://github.com/wujekbizon',
      followers_url: 'https://api.github.com/users/wujekbizon/followers',
      following_url:
        'https://api.github.com/users/wujekbizon/following{/other_user}',
      gists_url: 'https://api.github.com/users/wujekbizon/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/wujekbizon/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/wujekbizon/subscriptions',
      organizations_url: 'https://api.github.com/users/wujekbizon/orgs',
      repos_url: 'https://api.github.com/users/wujekbizon/repos',
      events_url: 'https://api.github.com/users/wujekbizon/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/wujekbizon/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/wujekbizon/react-jobster',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/wujekbizon/react-jobster',
    forks_url: 'https://api.github.com/repos/wujekbizon/react-jobster/forks',
    keys_url:
      'https://api.github.com/repos/wujekbizon/react-jobster/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/wujekbizon/react-jobster/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/wujekbizon/react-jobster/teams',
    hooks_url: 'https://api.github.com/repos/wujekbizon/react-jobster/hooks',
    issue_events_url:
      'https://api.github.com/repos/wujekbizon/react-jobster/issues/events{/number}',
    events_url: 'https://api.github.com/repos/wujekbizon/react-jobster/events',
    assignees_url:
      'https://api.github.com/repos/wujekbizon/react-jobster/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/wujekbizon/react-jobster/branches{/branch}',
    tags_url: 'https://api.github.com/repos/wujekbizon/react-jobster/tags',
    blobs_url:
      'https://api.github.com/repos/wujekbizon/react-jobster/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/wujekbizon/react-jobster/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/wujekbizon/react-jobster/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/wujekbizon/react-jobster/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/wujekbizon/react-jobster/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/wujekbizon/react-jobster/languages',
    stargazers_url:
      'https://api.github.com/repos/wujekbizon/react-jobster/stargazers',
    contributors_url:
      'https://api.github.com/repos/wujekbizon/react-jobster/contributors',
    subscribers_url:
      'https://api.github.com/repos/wujekbizon/react-jobster/subscribers',
    subscription_url:
      'https://api.github.com/repos/wujekbizon/react-jobster/subscription',
    commits_url:
      'https://api.github.com/repos/wujekbizon/react-jobster/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/wujekbizon/react-jobster/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/wujekbizon/react-jobster/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/wujekbizon/react-jobster/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/wujekbizon/react-jobster/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/wujekbizon/react-jobster/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/wujekbizon/react-jobster/merges',
    archive_url:
      'https://api.github.com/repos/wujekbizon/react-jobster/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/wujekbizon/react-jobster/downloads',
    issues_url:
      'https://api.github.com/repos/wujekbizon/react-jobster/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/wujekbizon/react-jobster/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/wujekbizon/react-jobster/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/wujekbizon/react-jobster/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/wujekbizon/react-jobster/labels{/name}',
    releases_url:
      'https://api.github.com/repos/wujekbizon/react-jobster/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/wujekbizon/react-jobster/deployments',
    created_at: '2022-07-11T05:52:51Z',
    updated_at: '2022-07-11T05:58:50Z',
    pushed_at: '2022-07-11T05:54:07Z',
    git_url: 'git://github.com/wujekbizon/react-jobster.git',
    ssh_url: 'git@github.com:wujekbizon/react-jobster.git',
    clone_url: 'https://github.com/wujekbizon/react-jobster.git',
    svn_url: 'https://github.com/wujekbizon/react-jobster',
    homepage: 'react-jobster.vercel.app',
    size: 372,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 500907049,
    node_id: 'R_kgDOHds8KQ',
    name: 'react-mwd',
    full_name: 'wujekbizon/react-mwd',
    private: false,
    owner: {
      login: 'wujekbizon',
      id: 97871150,
      node_id: 'U_kgDOBdVlLg',
      avatar_url: 'https://avatars.githubusercontent.com/u/97871150?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/wujekbizon',
      html_url: 'https://github.com/wujekbizon',
      followers_url: 'https://api.github.com/users/wujekbizon/followers',
      following_url:
        'https://api.github.com/users/wujekbizon/following{/other_user}',
      gists_url: 'https://api.github.com/users/wujekbizon/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/wujekbizon/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/wujekbizon/subscriptions',
      organizations_url: 'https://api.github.com/users/wujekbizon/orgs',
      repos_url: 'https://api.github.com/users/wujekbizon/repos',
      events_url: 'https://api.github.com/users/wujekbizon/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/wujekbizon/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/wujekbizon/react-mwd',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/wujekbizon/react-mwd',
    forks_url: 'https://api.github.com/repos/wujekbizon/react-mwd/forks',
    keys_url: 'https://api.github.com/repos/wujekbizon/react-mwd/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/wujekbizon/react-mwd/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/wujekbizon/react-mwd/teams',
    hooks_url: 'https://api.github.com/repos/wujekbizon/react-mwd/hooks',
    issue_events_url:
      'https://api.github.com/repos/wujekbizon/react-mwd/issues/events{/number}',
    events_url: 'https://api.github.com/repos/wujekbizon/react-mwd/events',
    assignees_url:
      'https://api.github.com/repos/wujekbizon/react-mwd/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/wujekbizon/react-mwd/branches{/branch}',
    tags_url: 'https://api.github.com/repos/wujekbizon/react-mwd/tags',
    blobs_url:
      'https://api.github.com/repos/wujekbizon/react-mwd/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/wujekbizon/react-mwd/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/wujekbizon/react-mwd/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/wujekbizon/react-mwd/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/wujekbizon/react-mwd/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/wujekbizon/react-mwd/languages',
    stargazers_url:
      'https://api.github.com/repos/wujekbizon/react-mwd/stargazers',
    contributors_url:
      'https://api.github.com/repos/wujekbizon/react-mwd/contributors',
    subscribers_url:
      'https://api.github.com/repos/wujekbizon/react-mwd/subscribers',
    subscription_url:
      'https://api.github.com/repos/wujekbizon/react-mwd/subscription',
    commits_url:
      'https://api.github.com/repos/wujekbizon/react-mwd/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/wujekbizon/react-mwd/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/wujekbizon/react-mwd/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/wujekbizon/react-mwd/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/wujekbizon/react-mwd/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/wujekbizon/react-mwd/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/wujekbizon/react-mwd/merges',
    archive_url:
      'https://api.github.com/repos/wujekbizon/react-mwd/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/wujekbizon/react-mwd/downloads',
    issues_url:
      'https://api.github.com/repos/wujekbizon/react-mwd/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/wujekbizon/react-mwd/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/wujekbizon/react-mwd/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/wujekbizon/react-mwd/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/wujekbizon/react-mwd/labels{/name}',
    releases_url:
      'https://api.github.com/repos/wujekbizon/react-mwd/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/wujekbizon/react-mwd/deployments',
    created_at: '2022-06-07T15:53:12Z',
    updated_at: '2022-06-23T06:02:43Z',
    pushed_at: '2022-06-30T09:27:47Z',
    git_url: 'git://github.com/wujekbizon/react-mwd.git',
    ssh_url: 'git@github.com:wujekbizon/react-mwd.git',
    clone_url: 'https://github.com/wujekbizon/react-mwd.git',
    svn_url: 'https://github.com/wujekbizon/react-mwd',
    homepage: 'react-mwd-store.vercel.app',
    size: 1049,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 482897768,
    node_id: 'R_kgDOHMhvaA',
    name: 'react-portfolio',
    full_name: 'wujekbizon/react-portfolio',
    private: false,
    owner: {
      login: 'wujekbizon',
      id: 97871150,
      node_id: 'U_kgDOBdVlLg',
      avatar_url: 'https://avatars.githubusercontent.com/u/97871150?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/wujekbizon',
      html_url: 'https://github.com/wujekbizon',
      followers_url: 'https://api.github.com/users/wujekbizon/followers',
      following_url:
        'https://api.github.com/users/wujekbizon/following{/other_user}',
      gists_url: 'https://api.github.com/users/wujekbizon/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/wujekbizon/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/wujekbizon/subscriptions',
      organizations_url: 'https://api.github.com/users/wujekbizon/orgs',
      repos_url: 'https://api.github.com/users/wujekbizon/repos',
      events_url: 'https://api.github.com/users/wujekbizon/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/wujekbizon/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/wujekbizon/react-portfolio',
    description: 'my react portfolio',
    fork: false,
    url: 'https://api.github.com/repos/wujekbizon/react-portfolio',
    forks_url: 'https://api.github.com/repos/wujekbizon/react-portfolio/forks',
    keys_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/wujekbizon/react-portfolio/teams',
    hooks_url: 'https://api.github.com/repos/wujekbizon/react-portfolio/hooks',
    issue_events_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio/events',
    assignees_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio/branches{/branch}',
    tags_url: 'https://api.github.com/repos/wujekbizon/react-portfolio/tags',
    blobs_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio/languages',
    stargazers_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio/stargazers',
    contributors_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio/contributors',
    subscribers_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio/subscribers',
    subscription_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio/subscription',
    commits_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio/merges',
    archive_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio/downloads',
    issues_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio/labels{/name}',
    releases_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio/deployments',
    created_at: '2022-04-18T15:30:19Z',
    updated_at: '2022-04-24T16:42:11Z',
    pushed_at: '2022-04-28T09:43:35Z',
    git_url: 'git://github.com/wujekbizon/react-portfolio.git',
    ssh_url: 'git@github.com:wujekbizon/react-portfolio.git',
    clone_url: 'https://github.com/wujekbizon/react-portfolio.git',
    svn_url: 'https://github.com/wujekbizon/react-portfolio',
    homepage: 'react-portfolio-phi-seven.vercel.app',
    size: 1911,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 492935029,
    node_id: 'R_kgDOHWGXdQ',
    name: 'react-portfolio-v2.0',
    full_name: 'wujekbizon/react-portfolio-v2.0',
    private: false,
    owner: {
      login: 'wujekbizon',
      id: 97871150,
      node_id: 'U_kgDOBdVlLg',
      avatar_url: 'https://avatars.githubusercontent.com/u/97871150?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/wujekbizon',
      html_url: 'https://github.com/wujekbizon',
      followers_url: 'https://api.github.com/users/wujekbizon/followers',
      following_url:
        'https://api.github.com/users/wujekbizon/following{/other_user}',
      gists_url: 'https://api.github.com/users/wujekbizon/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/wujekbizon/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/wujekbizon/subscriptions',
      organizations_url: 'https://api.github.com/users/wujekbizon/orgs',
      repos_url: 'https://api.github.com/users/wujekbizon/repos',
      events_url: 'https://api.github.com/users/wujekbizon/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/wujekbizon/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/wujekbizon/react-portfolio-v2.0',
    description: 'My newest portfolio made in React',
    fork: false,
    url: 'https://api.github.com/repos/wujekbizon/react-portfolio-v2.0',
    forks_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio-v2.0/forks',
    keys_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio-v2.0/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio-v2.0/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio-v2.0/teams',
    hooks_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio-v2.0/hooks',
    issue_events_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio-v2.0/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio-v2.0/events',
    assignees_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio-v2.0/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio-v2.0/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio-v2.0/tags',
    blobs_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio-v2.0/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio-v2.0/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio-v2.0/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio-v2.0/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio-v2.0/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio-v2.0/languages',
    stargazers_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio-v2.0/stargazers',
    contributors_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio-v2.0/contributors',
    subscribers_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio-v2.0/subscribers',
    subscription_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio-v2.0/subscription',
    commits_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio-v2.0/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio-v2.0/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio-v2.0/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio-v2.0/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio-v2.0/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio-v2.0/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio-v2.0/merges',
    archive_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio-v2.0/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio-v2.0/downloads',
    issues_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio-v2.0/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio-v2.0/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio-v2.0/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio-v2.0/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio-v2.0/labels{/name}',
    releases_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio-v2.0/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/wujekbizon/react-portfolio-v2.0/deployments',
    created_at: '2022-05-16T17:28:42Z',
    updated_at: '2022-05-22T08:09:06Z',
    pushed_at: '2022-07-11T10:46:54Z',
    git_url: 'git://github.com/wujekbizon/react-portfolio-v2.0.git',
    ssh_url: 'git@github.com:wujekbizon/react-portfolio-v2.0.git',
    clone_url: 'https://github.com/wujekbizon/react-portfolio-v2.0.git',
    svn_url: 'https://github.com/wujekbizon/react-portfolio-v2.0',
    homepage: 'react-portfolio-v2-0.vercel.app',
    size: 6771,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'SCSS',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 491765915,
    node_id: 'R_kgDOHU_Amw',
    name: 'react-project-videos',
    full_name: 'wujekbizon/react-project-videos',
    private: false,
    owner: {
      login: 'wujekbizon',
      id: 97871150,
      node_id: 'U_kgDOBdVlLg',
      avatar_url: 'https://avatars.githubusercontent.com/u/97871150?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/wujekbizon',
      html_url: 'https://github.com/wujekbizon',
      followers_url: 'https://api.github.com/users/wujekbizon/followers',
      following_url:
        'https://api.github.com/users/wujekbizon/following{/other_user}',
      gists_url: 'https://api.github.com/users/wujekbizon/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/wujekbizon/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/wujekbizon/subscriptions',
      organizations_url: 'https://api.github.com/users/wujekbizon/orgs',
      repos_url: 'https://api.github.com/users/wujekbizon/repos',
      events_url: 'https://api.github.com/users/wujekbizon/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/wujekbizon/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/wujekbizon/react-project-videos',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/wujekbizon/react-project-videos',
    forks_url:
      'https://api.github.com/repos/wujekbizon/react-project-videos/forks',
    keys_url:
      'https://api.github.com/repos/wujekbizon/react-project-videos/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/wujekbizon/react-project-videos/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/wujekbizon/react-project-videos/teams',
    hooks_url:
      'https://api.github.com/repos/wujekbizon/react-project-videos/hooks',
    issue_events_url:
      'https://api.github.com/repos/wujekbizon/react-project-videos/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/wujekbizon/react-project-videos/events',
    assignees_url:
      'https://api.github.com/repos/wujekbizon/react-project-videos/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/wujekbizon/react-project-videos/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/wujekbizon/react-project-videos/tags',
    blobs_url:
      'https://api.github.com/repos/wujekbizon/react-project-videos/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/wujekbizon/react-project-videos/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/wujekbizon/react-project-videos/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/wujekbizon/react-project-videos/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/wujekbizon/react-project-videos/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/wujekbizon/react-project-videos/languages',
    stargazers_url:
      'https://api.github.com/repos/wujekbizon/react-project-videos/stargazers',
    contributors_url:
      'https://api.github.com/repos/wujekbizon/react-project-videos/contributors',
    subscribers_url:
      'https://api.github.com/repos/wujekbizon/react-project-videos/subscribers',
    subscription_url:
      'https://api.github.com/repos/wujekbizon/react-project-videos/subscription',
    commits_url:
      'https://api.github.com/repos/wujekbizon/react-project-videos/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/wujekbizon/react-project-videos/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/wujekbizon/react-project-videos/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/wujekbizon/react-project-videos/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/wujekbizon/react-project-videos/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/wujekbizon/react-project-videos/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/wujekbizon/react-project-videos/merges',
    archive_url:
      'https://api.github.com/repos/wujekbizon/react-project-videos/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/wujekbizon/react-project-videos/downloads',
    issues_url:
      'https://api.github.com/repos/wujekbizon/react-project-videos/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/wujekbizon/react-project-videos/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/wujekbizon/react-project-videos/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/wujekbizon/react-project-videos/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/wujekbizon/react-project-videos/labels{/name}',
    releases_url:
      'https://api.github.com/repos/wujekbizon/react-project-videos/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/wujekbizon/react-project-videos/deployments',
    created_at: '2022-05-13T05:17:04Z',
    updated_at: '2022-05-13T12:42:51Z',
    pushed_at: '2022-05-13T17:38:17Z',
    git_url: 'git://github.com/wujekbizon/react-project-videos.git',
    ssh_url: 'git@github.com:wujekbizon/react-project-videos.git',
    clone_url: 'https://github.com/wujekbizon/react-project-videos.git',
    svn_url: 'https://github.com/wujekbizon/react-project-videos',
    homepage: null,
    size: 333,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 513198914,
    node_id: 'R_kgDOHpbLQg',
    name: 'react-smakus',
    full_name: 'wujekbizon/react-smakus',
    private: false,
    owner: {
      login: 'wujekbizon',
      id: 97871150,
      node_id: 'U_kgDOBdVlLg',
      avatar_url: 'https://avatars.githubusercontent.com/u/97871150?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/wujekbizon',
      html_url: 'https://github.com/wujekbizon',
      followers_url: 'https://api.github.com/users/wujekbizon/followers',
      following_url:
        'https://api.github.com/users/wujekbizon/following{/other_user}',
      gists_url: 'https://api.github.com/users/wujekbizon/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/wujekbizon/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/wujekbizon/subscriptions',
      organizations_url: 'https://api.github.com/users/wujekbizon/orgs',
      repos_url: 'https://api.github.com/users/wujekbizon/repos',
      events_url: 'https://api.github.com/users/wujekbizon/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/wujekbizon/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/wujekbizon/react-smakus',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/wujekbizon/react-smakus',
    forks_url: 'https://api.github.com/repos/wujekbizon/react-smakus/forks',
    keys_url:
      'https://api.github.com/repos/wujekbizon/react-smakus/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/wujekbizon/react-smakus/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/wujekbizon/react-smakus/teams',
    hooks_url: 'https://api.github.com/repos/wujekbizon/react-smakus/hooks',
    issue_events_url:
      'https://api.github.com/repos/wujekbizon/react-smakus/issues/events{/number}',
    events_url: 'https://api.github.com/repos/wujekbizon/react-smakus/events',
    assignees_url:
      'https://api.github.com/repos/wujekbizon/react-smakus/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/wujekbizon/react-smakus/branches{/branch}',
    tags_url: 'https://api.github.com/repos/wujekbizon/react-smakus/tags',
    blobs_url:
      'https://api.github.com/repos/wujekbizon/react-smakus/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/wujekbizon/react-smakus/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/wujekbizon/react-smakus/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/wujekbizon/react-smakus/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/wujekbizon/react-smakus/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/wujekbizon/react-smakus/languages',
    stargazers_url:
      'https://api.github.com/repos/wujekbizon/react-smakus/stargazers',
    contributors_url:
      'https://api.github.com/repos/wujekbizon/react-smakus/contributors',
    subscribers_url:
      'https://api.github.com/repos/wujekbizon/react-smakus/subscribers',
    subscription_url:
      'https://api.github.com/repos/wujekbizon/react-smakus/subscription',
    commits_url:
      'https://api.github.com/repos/wujekbizon/react-smakus/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/wujekbizon/react-smakus/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/wujekbizon/react-smakus/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/wujekbizon/react-smakus/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/wujekbizon/react-smakus/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/wujekbizon/react-smakus/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/wujekbizon/react-smakus/merges',
    archive_url:
      'https://api.github.com/repos/wujekbizon/react-smakus/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/wujekbizon/react-smakus/downloads',
    issues_url:
      'https://api.github.com/repos/wujekbizon/react-smakus/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/wujekbizon/react-smakus/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/wujekbizon/react-smakus/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/wujekbizon/react-smakus/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/wujekbizon/react-smakus/labels{/name}',
    releases_url:
      'https://api.github.com/repos/wujekbizon/react-smakus/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/wujekbizon/react-smakus/deployments',
    created_at: '2022-07-12T15:37:37Z',
    updated_at: '2022-07-12T15:40:17Z',
    pushed_at: '2022-07-16T16:33:39Z',
    git_url: 'git://github.com/wujekbizon/react-smakus.git',
    ssh_url: 'git@github.com:wujekbizon/react-smakus.git',
    clone_url: 'https://github.com/wujekbizon/react-smakus.git',
    svn_url: 'https://github.com/wujekbizon/react-smakus',
    homepage: 'bar-smakus.vercel.app',
    size: 1187,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 506514702,
    node_id: 'R_kgDOHjDNDg',
    name: 'react-start-new-app',
    full_name: 'wujekbizon/react-start-new-app',
    private: false,
    owner: {
      login: 'wujekbizon',
      id: 97871150,
      node_id: 'U_kgDOBdVlLg',
      avatar_url: 'https://avatars.githubusercontent.com/u/97871150?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/wujekbizon',
      html_url: 'https://github.com/wujekbizon',
      followers_url: 'https://api.github.com/users/wujekbizon/followers',
      following_url:
        'https://api.github.com/users/wujekbizon/following{/other_user}',
      gists_url: 'https://api.github.com/users/wujekbizon/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/wujekbizon/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/wujekbizon/subscriptions',
      organizations_url: 'https://api.github.com/users/wujekbizon/orgs',
      repos_url: 'https://api.github.com/users/wujekbizon/repos',
      events_url: 'https://api.github.com/users/wujekbizon/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/wujekbizon/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/wujekbizon/react-start-new-app',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/wujekbizon/react-start-new-app',
    forks_url:
      'https://api.github.com/repos/wujekbizon/react-start-new-app/forks',
    keys_url:
      'https://api.github.com/repos/wujekbizon/react-start-new-app/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/wujekbizon/react-start-new-app/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/wujekbizon/react-start-new-app/teams',
    hooks_url:
      'https://api.github.com/repos/wujekbizon/react-start-new-app/hooks',
    issue_events_url:
      'https://api.github.com/repos/wujekbizon/react-start-new-app/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/wujekbizon/react-start-new-app/events',
    assignees_url:
      'https://api.github.com/repos/wujekbizon/react-start-new-app/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/wujekbizon/react-start-new-app/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/wujekbizon/react-start-new-app/tags',
    blobs_url:
      'https://api.github.com/repos/wujekbizon/react-start-new-app/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/wujekbizon/react-start-new-app/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/wujekbizon/react-start-new-app/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/wujekbizon/react-start-new-app/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/wujekbizon/react-start-new-app/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/wujekbizon/react-start-new-app/languages',
    stargazers_url:
      'https://api.github.com/repos/wujekbizon/react-start-new-app/stargazers',
    contributors_url:
      'https://api.github.com/repos/wujekbizon/react-start-new-app/contributors',
    subscribers_url:
      'https://api.github.com/repos/wujekbizon/react-start-new-app/subscribers',
    subscription_url:
      'https://api.github.com/repos/wujekbizon/react-start-new-app/subscription',
    commits_url:
      'https://api.github.com/repos/wujekbizon/react-start-new-app/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/wujekbizon/react-start-new-app/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/wujekbizon/react-start-new-app/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/wujekbizon/react-start-new-app/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/wujekbizon/react-start-new-app/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/wujekbizon/react-start-new-app/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/wujekbizon/react-start-new-app/merges',
    archive_url:
      'https://api.github.com/repos/wujekbizon/react-start-new-app/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/wujekbizon/react-start-new-app/downloads',
    issues_url:
      'https://api.github.com/repos/wujekbizon/react-start-new-app/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/wujekbizon/react-start-new-app/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/wujekbizon/react-start-new-app/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/wujekbizon/react-start-new-app/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/wujekbizon/react-start-new-app/labels{/name}',
    releases_url:
      'https://api.github.com/repos/wujekbizon/react-start-new-app/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/wujekbizon/react-start-new-app/deployments',
    created_at: '2022-06-23T05:57:38Z',
    updated_at: '2022-06-23T06:39:41Z',
    pushed_at: '2022-06-23T06:40:29Z',
    git_url: 'git://github.com/wujekbizon/react-start-new-app.git',
    ssh_url: 'git@github.com:wujekbizon/react-start-new-app.git',
    clone_url: 'https://github.com/wujekbizon/react-start-new-app.git',
    svn_url: 'https://github.com/wujekbizon/react-start-new-app',
    homepage: null,
    size: 301,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'HTML',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 500046825,
    node_id: 'R_kgDOHc4b6Q',
    name: 'react-streams',
    full_name: 'wujekbizon/react-streams',
    private: false,
    owner: {
      login: 'wujekbizon',
      id: 97871150,
      node_id: 'U_kgDOBdVlLg',
      avatar_url: 'https://avatars.githubusercontent.com/u/97871150?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/wujekbizon',
      html_url: 'https://github.com/wujekbizon',
      followers_url: 'https://api.github.com/users/wujekbizon/followers',
      following_url:
        'https://api.github.com/users/wujekbizon/following{/other_user}',
      gists_url: 'https://api.github.com/users/wujekbizon/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/wujekbizon/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/wujekbizon/subscriptions',
      organizations_url: 'https://api.github.com/users/wujekbizon/orgs',
      repos_url: 'https://api.github.com/users/wujekbizon/repos',
      events_url: 'https://api.github.com/users/wujekbizon/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/wujekbizon/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/wujekbizon/react-streams',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/wujekbizon/react-streams',
    forks_url: 'https://api.github.com/repos/wujekbizon/react-streams/forks',
    keys_url:
      'https://api.github.com/repos/wujekbizon/react-streams/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/wujekbizon/react-streams/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/wujekbizon/react-streams/teams',
    hooks_url: 'https://api.github.com/repos/wujekbizon/react-streams/hooks',
    issue_events_url:
      'https://api.github.com/repos/wujekbizon/react-streams/issues/events{/number}',
    events_url: 'https://api.github.com/repos/wujekbizon/react-streams/events',
    assignees_url:
      'https://api.github.com/repos/wujekbizon/react-streams/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/wujekbizon/react-streams/branches{/branch}',
    tags_url: 'https://api.github.com/repos/wujekbizon/react-streams/tags',
    blobs_url:
      'https://api.github.com/repos/wujekbizon/react-streams/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/wujekbizon/react-streams/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/wujekbizon/react-streams/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/wujekbizon/react-streams/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/wujekbizon/react-streams/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/wujekbizon/react-streams/languages',
    stargazers_url:
      'https://api.github.com/repos/wujekbizon/react-streams/stargazers',
    contributors_url:
      'https://api.github.com/repos/wujekbizon/react-streams/contributors',
    subscribers_url:
      'https://api.github.com/repos/wujekbizon/react-streams/subscribers',
    subscription_url:
      'https://api.github.com/repos/wujekbizon/react-streams/subscription',
    commits_url:
      'https://api.github.com/repos/wujekbizon/react-streams/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/wujekbizon/react-streams/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/wujekbizon/react-streams/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/wujekbizon/react-streams/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/wujekbizon/react-streams/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/wujekbizon/react-streams/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/wujekbizon/react-streams/merges',
    archive_url:
      'https://api.github.com/repos/wujekbizon/react-streams/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/wujekbizon/react-streams/downloads',
    issues_url:
      'https://api.github.com/repos/wujekbizon/react-streams/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/wujekbizon/react-streams/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/wujekbizon/react-streams/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/wujekbizon/react-streams/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/wujekbizon/react-streams/labels{/name}',
    releases_url:
      'https://api.github.com/repos/wujekbizon/react-streams/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/wujekbizon/react-streams/deployments',
    created_at: '2022-06-05T08:57:41Z',
    updated_at: '2022-06-05T09:01:45Z',
    pushed_at: '2022-06-05T09:01:42Z',
    git_url: 'git://github.com/wujekbizon/react-streams.git',
    ssh_url: 'git@github.com:wujekbizon/react-streams.git',
    clone_url: 'https://github.com/wujekbizon/react-streams.git',
    svn_url: 'https://github.com/wujekbizon/react-streams',
    homepage: null,
    size: 308,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 489272025,
    node_id: 'R_kgDOHSmy2Q',
    name: 'react-ts-mtg',
    full_name: 'wujekbizon/react-ts-mtg',
    private: false,
    owner: {
      login: 'wujekbizon',
      id: 97871150,
      node_id: 'U_kgDOBdVlLg',
      avatar_url: 'https://avatars.githubusercontent.com/u/97871150?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/wujekbizon',
      html_url: 'https://github.com/wujekbizon',
      followers_url: 'https://api.github.com/users/wujekbizon/followers',
      following_url:
        'https://api.github.com/users/wujekbizon/following{/other_user}',
      gists_url: 'https://api.github.com/users/wujekbizon/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/wujekbizon/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/wujekbizon/subscriptions',
      organizations_url: 'https://api.github.com/users/wujekbizon/orgs',
      repos_url: 'https://api.github.com/users/wujekbizon/repos',
      events_url: 'https://api.github.com/users/wujekbizon/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/wujekbizon/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/wujekbizon/react-ts-mtg',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/wujekbizon/react-ts-mtg',
    forks_url: 'https://api.github.com/repos/wujekbizon/react-ts-mtg/forks',
    keys_url:
      'https://api.github.com/repos/wujekbizon/react-ts-mtg/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/wujekbizon/react-ts-mtg/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/wujekbizon/react-ts-mtg/teams',
    hooks_url: 'https://api.github.com/repos/wujekbizon/react-ts-mtg/hooks',
    issue_events_url:
      'https://api.github.com/repos/wujekbizon/react-ts-mtg/issues/events{/number}',
    events_url: 'https://api.github.com/repos/wujekbizon/react-ts-mtg/events',
    assignees_url:
      'https://api.github.com/repos/wujekbizon/react-ts-mtg/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/wujekbizon/react-ts-mtg/branches{/branch}',
    tags_url: 'https://api.github.com/repos/wujekbizon/react-ts-mtg/tags',
    blobs_url:
      'https://api.github.com/repos/wujekbizon/react-ts-mtg/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/wujekbizon/react-ts-mtg/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/wujekbizon/react-ts-mtg/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/wujekbizon/react-ts-mtg/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/wujekbizon/react-ts-mtg/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/wujekbizon/react-ts-mtg/languages',
    stargazers_url:
      'https://api.github.com/repos/wujekbizon/react-ts-mtg/stargazers',
    contributors_url:
      'https://api.github.com/repos/wujekbizon/react-ts-mtg/contributors',
    subscribers_url:
      'https://api.github.com/repos/wujekbizon/react-ts-mtg/subscribers',
    subscription_url:
      'https://api.github.com/repos/wujekbizon/react-ts-mtg/subscription',
    commits_url:
      'https://api.github.com/repos/wujekbizon/react-ts-mtg/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/wujekbizon/react-ts-mtg/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/wujekbizon/react-ts-mtg/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/wujekbizon/react-ts-mtg/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/wujekbizon/react-ts-mtg/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/wujekbizon/react-ts-mtg/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/wujekbizon/react-ts-mtg/merges',
    archive_url:
      'https://api.github.com/repos/wujekbizon/react-ts-mtg/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/wujekbizon/react-ts-mtg/downloads',
    issues_url:
      'https://api.github.com/repos/wujekbizon/react-ts-mtg/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/wujekbizon/react-ts-mtg/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/wujekbizon/react-ts-mtg/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/wujekbizon/react-ts-mtg/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/wujekbizon/react-ts-mtg/labels{/name}',
    releases_url:
      'https://api.github.com/repos/wujekbizon/react-ts-mtg/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/wujekbizon/react-ts-mtg/deployments',
    created_at: '2022-05-06T08:14:54Z',
    updated_at: '2022-05-29T05:47:45Z',
    pushed_at: '2022-05-28T17:26:18Z',
    git_url: 'git://github.com/wujekbizon/react-ts-mtg.git',
    ssh_url: 'git@github.com:wujekbizon/react-ts-mtg.git',
    clone_url: 'https://github.com/wujekbizon/react-ts-mtg.git',
    svn_url: 'https://github.com/wujekbizon/react-ts-mtg',
    homepage: 'react-ts-mtg.vercel.app',
    size: 2005,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'TypeScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 488598598,
    node_id: 'R_kgDOHR9sRg',
    name: 'react-ts-quiz',
    full_name: 'wujekbizon/react-ts-quiz',
    private: false,
    owner: {
      login: 'wujekbizon',
      id: 97871150,
      node_id: 'U_kgDOBdVlLg',
      avatar_url: 'https://avatars.githubusercontent.com/u/97871150?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/wujekbizon',
      html_url: 'https://github.com/wujekbizon',
      followers_url: 'https://api.github.com/users/wujekbizon/followers',
      following_url:
        'https://api.github.com/users/wujekbizon/following{/other_user}',
      gists_url: 'https://api.github.com/users/wujekbizon/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/wujekbizon/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/wujekbizon/subscriptions',
      organizations_url: 'https://api.github.com/users/wujekbizon/orgs',
      repos_url: 'https://api.github.com/users/wujekbizon/repos',
      events_url: 'https://api.github.com/users/wujekbizon/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/wujekbizon/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/wujekbizon/react-ts-quiz',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/wujekbizon/react-ts-quiz',
    forks_url: 'https://api.github.com/repos/wujekbizon/react-ts-quiz/forks',
    keys_url:
      'https://api.github.com/repos/wujekbizon/react-ts-quiz/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/wujekbizon/react-ts-quiz/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/wujekbizon/react-ts-quiz/teams',
    hooks_url: 'https://api.github.com/repos/wujekbizon/react-ts-quiz/hooks',
    issue_events_url:
      'https://api.github.com/repos/wujekbizon/react-ts-quiz/issues/events{/number}',
    events_url: 'https://api.github.com/repos/wujekbizon/react-ts-quiz/events',
    assignees_url:
      'https://api.github.com/repos/wujekbizon/react-ts-quiz/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/wujekbizon/react-ts-quiz/branches{/branch}',
    tags_url: 'https://api.github.com/repos/wujekbizon/react-ts-quiz/tags',
    blobs_url:
      'https://api.github.com/repos/wujekbizon/react-ts-quiz/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/wujekbizon/react-ts-quiz/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/wujekbizon/react-ts-quiz/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/wujekbizon/react-ts-quiz/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/wujekbizon/react-ts-quiz/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/wujekbizon/react-ts-quiz/languages',
    stargazers_url:
      'https://api.github.com/repos/wujekbizon/react-ts-quiz/stargazers',
    contributors_url:
      'https://api.github.com/repos/wujekbizon/react-ts-quiz/contributors',
    subscribers_url:
      'https://api.github.com/repos/wujekbizon/react-ts-quiz/subscribers',
    subscription_url:
      'https://api.github.com/repos/wujekbizon/react-ts-quiz/subscription',
    commits_url:
      'https://api.github.com/repos/wujekbizon/react-ts-quiz/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/wujekbizon/react-ts-quiz/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/wujekbizon/react-ts-quiz/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/wujekbizon/react-ts-quiz/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/wujekbizon/react-ts-quiz/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/wujekbizon/react-ts-quiz/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/wujekbizon/react-ts-quiz/merges',
    archive_url:
      'https://api.github.com/repos/wujekbizon/react-ts-quiz/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/wujekbizon/react-ts-quiz/downloads',
    issues_url:
      'https://api.github.com/repos/wujekbizon/react-ts-quiz/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/wujekbizon/react-ts-quiz/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/wujekbizon/react-ts-quiz/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/wujekbizon/react-ts-quiz/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/wujekbizon/react-ts-quiz/labels{/name}',
    releases_url:
      'https://api.github.com/repos/wujekbizon/react-ts-quiz/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/wujekbizon/react-ts-quiz/deployments',
    created_at: '2022-05-04T13:25:04Z',
    updated_at: '2022-05-04T13:27:32Z',
    pushed_at: '2022-05-04T13:27:28Z',
    git_url: 'git://github.com/wujekbizon/react-ts-quiz.git',
    ssh_url: 'git@github.com:wujekbizon/react-ts-quiz.git',
    clone_url: 'https://github.com/wujekbizon/react-ts-quiz.git',
    svn_url: 'https://github.com/wujekbizon/react-ts-quiz',
    homepage: null,
    size: 2020,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'TypeScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 488347653,
    node_id: 'R_kgDOHRuYBQ',
    name: 'react-ts-shopingCart',
    full_name: 'wujekbizon/react-ts-shopingCart',
    private: false,
    owner: {
      login: 'wujekbizon',
      id: 97871150,
      node_id: 'U_kgDOBdVlLg',
      avatar_url: 'https://avatars.githubusercontent.com/u/97871150?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/wujekbizon',
      html_url: 'https://github.com/wujekbizon',
      followers_url: 'https://api.github.com/users/wujekbizon/followers',
      following_url:
        'https://api.github.com/users/wujekbizon/following{/other_user}',
      gists_url: 'https://api.github.com/users/wujekbizon/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/wujekbizon/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/wujekbizon/subscriptions',
      organizations_url: 'https://api.github.com/users/wujekbizon/orgs',
      repos_url: 'https://api.github.com/users/wujekbizon/repos',
      events_url: 'https://api.github.com/users/wujekbizon/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/wujekbizon/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/wujekbizon/react-ts-shopingCart',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/wujekbizon/react-ts-shopingCart',
    forks_url:
      'https://api.github.com/repos/wujekbizon/react-ts-shopingCart/forks',
    keys_url:
      'https://api.github.com/repos/wujekbizon/react-ts-shopingCart/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/wujekbizon/react-ts-shopingCart/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/wujekbizon/react-ts-shopingCart/teams',
    hooks_url:
      'https://api.github.com/repos/wujekbizon/react-ts-shopingCart/hooks',
    issue_events_url:
      'https://api.github.com/repos/wujekbizon/react-ts-shopingCart/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/wujekbizon/react-ts-shopingCart/events',
    assignees_url:
      'https://api.github.com/repos/wujekbizon/react-ts-shopingCart/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/wujekbizon/react-ts-shopingCart/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/wujekbizon/react-ts-shopingCart/tags',
    blobs_url:
      'https://api.github.com/repos/wujekbizon/react-ts-shopingCart/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/wujekbizon/react-ts-shopingCart/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/wujekbizon/react-ts-shopingCart/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/wujekbizon/react-ts-shopingCart/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/wujekbizon/react-ts-shopingCart/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/wujekbizon/react-ts-shopingCart/languages',
    stargazers_url:
      'https://api.github.com/repos/wujekbizon/react-ts-shopingCart/stargazers',
    contributors_url:
      'https://api.github.com/repos/wujekbizon/react-ts-shopingCart/contributors',
    subscribers_url:
      'https://api.github.com/repos/wujekbizon/react-ts-shopingCart/subscribers',
    subscription_url:
      'https://api.github.com/repos/wujekbizon/react-ts-shopingCart/subscription',
    commits_url:
      'https://api.github.com/repos/wujekbizon/react-ts-shopingCart/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/wujekbizon/react-ts-shopingCart/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/wujekbizon/react-ts-shopingCart/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/wujekbizon/react-ts-shopingCart/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/wujekbizon/react-ts-shopingCart/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/wujekbizon/react-ts-shopingCart/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/wujekbizon/react-ts-shopingCart/merges',
    archive_url:
      'https://api.github.com/repos/wujekbizon/react-ts-shopingCart/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/wujekbizon/react-ts-shopingCart/downloads',
    issues_url:
      'https://api.github.com/repos/wujekbizon/react-ts-shopingCart/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/wujekbizon/react-ts-shopingCart/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/wujekbizon/react-ts-shopingCart/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/wujekbizon/react-ts-shopingCart/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/wujekbizon/react-ts-shopingCart/labels{/name}',
    releases_url:
      'https://api.github.com/repos/wujekbizon/react-ts-shopingCart/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/wujekbizon/react-ts-shopingCart/deployments',
    created_at: '2022-05-03T20:05:08Z',
    updated_at: '2022-05-03T20:05:42Z',
    pushed_at: '2022-05-03T20:05:39Z',
    git_url: 'git://github.com/wujekbizon/react-ts-shopingCart.git',
    ssh_url: 'git@github.com:wujekbizon/react-ts-shopingCart.git',
    clone_url: 'https://github.com/wujekbizon/react-ts-shopingCart.git',
    svn_url: 'https://github.com/wujekbizon/react-ts-shopingCart',
    homepage: null,
    size: 302,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'TypeScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 487787061,
    node_id: 'R_kgDOHRMKNQ',
    name: 'ts-projects-arkanoid',
    full_name: 'wujekbizon/ts-projects-arkanoid',
    private: false,
    owner: {
      login: 'wujekbizon',
      id: 97871150,
      node_id: 'U_kgDOBdVlLg',
      avatar_url: 'https://avatars.githubusercontent.com/u/97871150?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/wujekbizon',
      html_url: 'https://github.com/wujekbizon',
      followers_url: 'https://api.github.com/users/wujekbizon/followers',
      following_url:
        'https://api.github.com/users/wujekbizon/following{/other_user}',
      gists_url: 'https://api.github.com/users/wujekbizon/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/wujekbizon/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/wujekbizon/subscriptions',
      organizations_url: 'https://api.github.com/users/wujekbizon/orgs',
      repos_url: 'https://api.github.com/users/wujekbizon/repos',
      events_url: 'https://api.github.com/users/wujekbizon/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/wujekbizon/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/wujekbizon/ts-projects-arkanoid',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/wujekbizon/ts-projects-arkanoid',
    forks_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-arkanoid/forks',
    keys_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-arkanoid/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-arkanoid/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-arkanoid/teams',
    hooks_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-arkanoid/hooks',
    issue_events_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-arkanoid/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-arkanoid/events',
    assignees_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-arkanoid/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-arkanoid/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-arkanoid/tags',
    blobs_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-arkanoid/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-arkanoid/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-arkanoid/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-arkanoid/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-arkanoid/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-arkanoid/languages',
    stargazers_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-arkanoid/stargazers',
    contributors_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-arkanoid/contributors',
    subscribers_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-arkanoid/subscribers',
    subscription_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-arkanoid/subscription',
    commits_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-arkanoid/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-arkanoid/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-arkanoid/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-arkanoid/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-arkanoid/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-arkanoid/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-arkanoid/merges',
    archive_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-arkanoid/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-arkanoid/downloads',
    issues_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-arkanoid/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-arkanoid/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-arkanoid/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-arkanoid/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-arkanoid/labels{/name}',
    releases_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-arkanoid/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-arkanoid/deployments',
    created_at: '2022-05-02T09:30:30Z',
    updated_at: '2022-05-02T09:31:06Z',
    pushed_at: '2022-05-02T09:31:03Z',
    git_url: 'git://github.com/wujekbizon/ts-projects-arkanoid.git',
    ssh_url: 'git@github.com:wujekbizon/ts-projects-arkanoid.git',
    clone_url: 'https://github.com/wujekbizon/ts-projects-arkanoid.git',
    svn_url: 'https://github.com/wujekbizon/ts-projects-arkanoid',
    homepage: null,
    size: 1477,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'TypeScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 482238803,
    node_id: 'R_kgDOHL5hUw',
    name: 'ts-projects-maps',
    full_name: 'wujekbizon/ts-projects-maps',
    private: false,
    owner: {
      login: 'wujekbizon',
      id: 97871150,
      node_id: 'U_kgDOBdVlLg',
      avatar_url: 'https://avatars.githubusercontent.com/u/97871150?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/wujekbizon',
      html_url: 'https://github.com/wujekbizon',
      followers_url: 'https://api.github.com/users/wujekbizon/followers',
      following_url:
        'https://api.github.com/users/wujekbizon/following{/other_user}',
      gists_url: 'https://api.github.com/users/wujekbizon/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/wujekbizon/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/wujekbizon/subscriptions',
      organizations_url: 'https://api.github.com/users/wujekbizon/orgs',
      repos_url: 'https://api.github.com/users/wujekbizon/repos',
      events_url: 'https://api.github.com/users/wujekbizon/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/wujekbizon/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/wujekbizon/ts-projects-maps',
    description: 'reusable map project in Typescript',
    fork: false,
    url: 'https://api.github.com/repos/wujekbizon/ts-projects-maps',
    forks_url: 'https://api.github.com/repos/wujekbizon/ts-projects-maps/forks',
    keys_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-maps/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-maps/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/wujekbizon/ts-projects-maps/teams',
    hooks_url: 'https://api.github.com/repos/wujekbizon/ts-projects-maps/hooks',
    issue_events_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-maps/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-maps/events',
    assignees_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-maps/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-maps/branches{/branch}',
    tags_url: 'https://api.github.com/repos/wujekbizon/ts-projects-maps/tags',
    blobs_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-maps/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-maps/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-maps/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-maps/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-maps/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-maps/languages',
    stargazers_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-maps/stargazers',
    contributors_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-maps/contributors',
    subscribers_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-maps/subscribers',
    subscription_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-maps/subscription',
    commits_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-maps/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-maps/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-maps/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-maps/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-maps/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-maps/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-maps/merges',
    archive_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-maps/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-maps/downloads',
    issues_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-maps/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-maps/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-maps/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-maps/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-maps/labels{/name}',
    releases_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-maps/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-maps/deployments',
    created_at: '2022-04-16T11:44:25Z',
    updated_at: '2022-04-16T11:45:38Z',
    pushed_at: '2022-04-16T11:48:14Z',
    git_url: 'git://github.com/wujekbizon/ts-projects-maps.git',
    ssh_url: 'git@github.com:wujekbizon/ts-projects-maps.git',
    clone_url: 'https://github.com/wujekbizon/ts-projects-maps.git',
    svn_url: 'https://github.com/wujekbizon/ts-projects-maps',
    homepage: null,
    size: 3,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'TypeScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 487223589,
    node_id: 'R_kgDOHQpxJQ',
    name: 'ts-projects-server',
    full_name: 'wujekbizon/ts-projects-server',
    private: false,
    owner: {
      login: 'wujekbizon',
      id: 97871150,
      node_id: 'U_kgDOBdVlLg',
      avatar_url: 'https://avatars.githubusercontent.com/u/97871150?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/wujekbizon',
      html_url: 'https://github.com/wujekbizon',
      followers_url: 'https://api.github.com/users/wujekbizon/followers',
      following_url:
        'https://api.github.com/users/wujekbizon/following{/other_user}',
      gists_url: 'https://api.github.com/users/wujekbizon/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/wujekbizon/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/wujekbizon/subscriptions',
      organizations_url: 'https://api.github.com/users/wujekbizon/orgs',
      repos_url: 'https://api.github.com/users/wujekbizon/repos',
      events_url: 'https://api.github.com/users/wujekbizon/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/wujekbizon/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/wujekbizon/ts-projects-server',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/wujekbizon/ts-projects-server',
    forks_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-server/forks',
    keys_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-server/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-server/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-server/teams',
    hooks_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-server/hooks',
    issue_events_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-server/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-server/events',
    assignees_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-server/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-server/branches{/branch}',
    tags_url: 'https://api.github.com/repos/wujekbizon/ts-projects-server/tags',
    blobs_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-server/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-server/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-server/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-server/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-server/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-server/languages',
    stargazers_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-server/stargazers',
    contributors_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-server/contributors',
    subscribers_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-server/subscribers',
    subscription_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-server/subscription',
    commits_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-server/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-server/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-server/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-server/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-server/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-server/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-server/merges',
    archive_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-server/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-server/downloads',
    issues_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-server/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-server/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-server/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-server/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-server/labels{/name}',
    releases_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-server/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-server/deployments',
    created_at: '2022-04-30T08:29:55Z',
    updated_at: '2022-04-30T08:37:11Z',
    pushed_at: '2022-04-30T18:23:43Z',
    git_url: 'git://github.com/wujekbizon/ts-projects-server.git',
    ssh_url: 'git@github.com:wujekbizon/ts-projects-server.git',
    clone_url: 'https://github.com/wujekbizon/ts-projects-server.git',
    svn_url: 'https://github.com/wujekbizon/ts-projects-server',
    homepage: null,
    size: 34,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'TypeScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 484985458,
    node_id: 'R_kgDOHOhKcg',
    name: 'ts-projects-sort',
    full_name: 'wujekbizon/ts-projects-sort',
    private: false,
    owner: {
      login: 'wujekbizon',
      id: 97871150,
      node_id: 'U_kgDOBdVlLg',
      avatar_url: 'https://avatars.githubusercontent.com/u/97871150?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/wujekbizon',
      html_url: 'https://github.com/wujekbizon',
      followers_url: 'https://api.github.com/users/wujekbizon/followers',
      following_url:
        'https://api.github.com/users/wujekbizon/following{/other_user}',
      gists_url: 'https://api.github.com/users/wujekbizon/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/wujekbizon/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/wujekbizon/subscriptions',
      organizations_url: 'https://api.github.com/users/wujekbizon/orgs',
      repos_url: 'https://api.github.com/users/wujekbizon/repos',
      events_url: 'https://api.github.com/users/wujekbizon/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/wujekbizon/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/wujekbizon/ts-projects-sort',
    description: 'small sorting app in TS',
    fork: false,
    url: 'https://api.github.com/repos/wujekbizon/ts-projects-sort',
    forks_url: 'https://api.github.com/repos/wujekbizon/ts-projects-sort/forks',
    keys_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-sort/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-sort/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/wujekbizon/ts-projects-sort/teams',
    hooks_url: 'https://api.github.com/repos/wujekbizon/ts-projects-sort/hooks',
    issue_events_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-sort/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-sort/events',
    assignees_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-sort/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-sort/branches{/branch}',
    tags_url: 'https://api.github.com/repos/wujekbizon/ts-projects-sort/tags',
    blobs_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-sort/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-sort/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-sort/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-sort/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-sort/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-sort/languages',
    stargazers_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-sort/stargazers',
    contributors_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-sort/contributors',
    subscribers_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-sort/subscribers',
    subscription_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-sort/subscription',
    commits_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-sort/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-sort/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-sort/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-sort/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-sort/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-sort/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-sort/merges',
    archive_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-sort/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-sort/downloads',
    issues_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-sort/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-sort/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-sort/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-sort/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-sort/labels{/name}',
    releases_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-sort/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-sort/deployments',
    created_at: '2022-04-24T09:41:11Z',
    updated_at: '2022-04-24T16:05:00Z',
    pushed_at: '2022-04-24T16:23:16Z',
    git_url: 'git://github.com/wujekbizon/ts-projects-sort.git',
    ssh_url: 'git@github.com:wujekbizon/ts-projects-sort.git',
    clone_url: 'https://github.com/wujekbizon/ts-projects-sort.git',
    svn_url: 'https://github.com/wujekbizon/ts-projects-sort',
    homepage: null,
    size: 23,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 485313501,
    node_id: 'R_kgDOHO1L3Q',
    name: 'ts-projects-stats',
    full_name: 'wujekbizon/ts-projects-stats',
    private: false,
    owner: {
      login: 'wujekbizon',
      id: 97871150,
      node_id: 'U_kgDOBdVlLg',
      avatar_url: 'https://avatars.githubusercontent.com/u/97871150?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/wujekbizon',
      html_url: 'https://github.com/wujekbizon',
      followers_url: 'https://api.github.com/users/wujekbizon/followers',
      following_url:
        'https://api.github.com/users/wujekbizon/following{/other_user}',
      gists_url: 'https://api.github.com/users/wujekbizon/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/wujekbizon/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/wujekbizon/subscriptions',
      organizations_url: 'https://api.github.com/users/wujekbizon/orgs',
      repos_url: 'https://api.github.com/users/wujekbizon/repos',
      events_url: 'https://api.github.com/users/wujekbizon/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/wujekbizon/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/wujekbizon/ts-projects-stats',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/wujekbizon/ts-projects-stats',
    forks_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-stats/forks',
    keys_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-stats/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-stats/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-stats/teams',
    hooks_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-stats/hooks',
    issue_events_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-stats/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-stats/events',
    assignees_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-stats/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-stats/branches{/branch}',
    tags_url: 'https://api.github.com/repos/wujekbizon/ts-projects-stats/tags',
    blobs_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-stats/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-stats/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-stats/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-stats/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-stats/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-stats/languages',
    stargazers_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-stats/stargazers',
    contributors_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-stats/contributors',
    subscribers_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-stats/subscribers',
    subscription_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-stats/subscription',
    commits_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-stats/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-stats/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-stats/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-stats/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-stats/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-stats/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-stats/merges',
    archive_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-stats/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-stats/downloads',
    issues_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-stats/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-stats/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-stats/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-stats/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-stats/labels{/name}',
    releases_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-stats/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-stats/deployments',
    created_at: '2022-04-25T09:53:33Z',
    updated_at: '2022-04-25T09:56:20Z',
    pushed_at: '2022-04-25T17:42:58Z',
    git_url: 'git://github.com/wujekbizon/ts-projects-stats.git',
    ssh_url: 'git@github.com:wujekbizon/ts-projects-stats.git',
    clone_url: 'https://github.com/wujekbizon/ts-projects-stats.git',
    svn_url: 'https://github.com/wujekbizon/ts-projects-stats',
    homepage: null,
    size: 24,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 485635646,
    node_id: 'R_kgDOHPI2Pg',
    name: 'ts-projects-webFramework',
    full_name: 'wujekbizon/ts-projects-webFramework',
    private: false,
    owner: {
      login: 'wujekbizon',
      id: 97871150,
      node_id: 'U_kgDOBdVlLg',
      avatar_url: 'https://avatars.githubusercontent.com/u/97871150?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/wujekbizon',
      html_url: 'https://github.com/wujekbizon',
      followers_url: 'https://api.github.com/users/wujekbizon/followers',
      following_url:
        'https://api.github.com/users/wujekbizon/following{/other_user}',
      gists_url: 'https://api.github.com/users/wujekbizon/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/wujekbizon/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/wujekbizon/subscriptions',
      organizations_url: 'https://api.github.com/users/wujekbizon/orgs',
      repos_url: 'https://api.github.com/users/wujekbizon/repos',
      events_url: 'https://api.github.com/users/wujekbizon/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/wujekbizon/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/wujekbizon/ts-projects-webFramework',
    description: 'Framework to create web application ,  build in Typescript.',
    fork: false,
    url: 'https://api.github.com/repos/wujekbizon/ts-projects-webFramework',
    forks_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-webFramework/forks',
    keys_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-webFramework/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-webFramework/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-webFramework/teams',
    hooks_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-webFramework/hooks',
    issue_events_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-webFramework/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-webFramework/events',
    assignees_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-webFramework/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-webFramework/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-webFramework/tags',
    blobs_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-webFramework/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-webFramework/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-webFramework/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-webFramework/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-webFramework/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-webFramework/languages',
    stargazers_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-webFramework/stargazers',
    contributors_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-webFramework/contributors',
    subscribers_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-webFramework/subscribers',
    subscription_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-webFramework/subscription',
    commits_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-webFramework/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-webFramework/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-webFramework/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-webFramework/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-webFramework/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-webFramework/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-webFramework/merges',
    archive_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-webFramework/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-webFramework/downloads',
    issues_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-webFramework/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-webFramework/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-webFramework/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-webFramework/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-webFramework/labels{/name}',
    releases_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-webFramework/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/wujekbizon/ts-projects-webFramework/deployments',
    created_at: '2022-04-26T04:41:12Z',
    updated_at: '2022-04-26T05:36:07Z',
    pushed_at: '2022-04-29T06:53:46Z',
    git_url: 'git://github.com/wujekbizon/ts-projects-webFramework.git',
    ssh_url: 'git@github.com:wujekbizon/ts-projects-webFramework.git',
    clone_url: 'https://github.com/wujekbizon/ts-projects-webFramework.git',
    svn_url: 'https://github.com/wujekbizon/ts-projects-webFramework',
    homepage: null,
    size: 42,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'TypeScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 482024095,
    node_id: 'R_kgDOHLsanw',
    name: 'wujekbizon',
    full_name: 'wujekbizon/wujekbizon',
    private: false,
    owner: {
      login: 'wujekbizon',
      id: 97871150,
      node_id: 'U_kgDOBdVlLg',
      avatar_url: 'https://avatars.githubusercontent.com/u/97871150?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/wujekbizon',
      html_url: 'https://github.com/wujekbizon',
      followers_url: 'https://api.github.com/users/wujekbizon/followers',
      following_url:
        'https://api.github.com/users/wujekbizon/following{/other_user}',
      gists_url: 'https://api.github.com/users/wujekbizon/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/wujekbizon/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/wujekbizon/subscriptions',
      organizations_url: 'https://api.github.com/users/wujekbizon/orgs',
      repos_url: 'https://api.github.com/users/wujekbizon/repos',
      events_url: 'https://api.github.com/users/wujekbizon/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/wujekbizon/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/wujekbizon/wujekbizon',
    description: 'Config files for my GitHub profile.',
    fork: false,
    url: 'https://api.github.com/repos/wujekbizon/wujekbizon',
    forks_url: 'https://api.github.com/repos/wujekbizon/wujekbizon/forks',
    keys_url:
      'https://api.github.com/repos/wujekbizon/wujekbizon/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/wujekbizon/wujekbizon/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/wujekbizon/wujekbizon/teams',
    hooks_url: 'https://api.github.com/repos/wujekbizon/wujekbizon/hooks',
    issue_events_url:
      'https://api.github.com/repos/wujekbizon/wujekbizon/issues/events{/number}',
    events_url: 'https://api.github.com/repos/wujekbizon/wujekbizon/events',
    assignees_url:
      'https://api.github.com/repos/wujekbizon/wujekbizon/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/wujekbizon/wujekbizon/branches{/branch}',
    tags_url: 'https://api.github.com/repos/wujekbizon/wujekbizon/tags',
    blobs_url:
      'https://api.github.com/repos/wujekbizon/wujekbizon/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/wujekbizon/wujekbizon/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/wujekbizon/wujekbizon/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/wujekbizon/wujekbizon/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/wujekbizon/wujekbizon/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/wujekbizon/wujekbizon/languages',
    stargazers_url:
      'https://api.github.com/repos/wujekbizon/wujekbizon/stargazers',
    contributors_url:
      'https://api.github.com/repos/wujekbizon/wujekbizon/contributors',
    subscribers_url:
      'https://api.github.com/repos/wujekbizon/wujekbizon/subscribers',
    subscription_url:
      'https://api.github.com/repos/wujekbizon/wujekbizon/subscription',
    commits_url:
      'https://api.github.com/repos/wujekbizon/wujekbizon/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/wujekbizon/wujekbizon/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/wujekbizon/wujekbizon/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/wujekbizon/wujekbizon/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/wujekbizon/wujekbizon/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/wujekbizon/wujekbizon/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/wujekbizon/wujekbizon/merges',
    archive_url:
      'https://api.github.com/repos/wujekbizon/wujekbizon/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/wujekbizon/wujekbizon/downloads',
    issues_url:
      'https://api.github.com/repos/wujekbizon/wujekbizon/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/wujekbizon/wujekbizon/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/wujekbizon/wujekbizon/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/wujekbizon/wujekbizon/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/wujekbizon/wujekbizon/labels{/name}',
    releases_url:
      'https://api.github.com/repos/wujekbizon/wujekbizon/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/wujekbizon/wujekbizon/deployments',
    created_at: '2022-04-15T16:48:00Z',
    updated_at: '2022-04-15T18:57:00Z',
    pushed_at: '2022-06-23T05:36:02Z',
    git_url: 'git://github.com/wujekbizon/wujekbizon.git',
    ssh_url: 'git@github.com:wujekbizon/wujekbizon.git',
    clone_url: 'https://github.com/wujekbizon/wujekbizon.git',
    svn_url: 'https://github.com/wujekbizon/wujekbizon',
    homepage: 'https://github.com/grzegorz.wolfinger',
    size: 22,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: false,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
];
